import { useEffect, useRef, useState, useCallback,memo } from "react";
import debounce from "../../helper/debounce";

function useArrayRef() {
	const refs = [];
	return [refs, (el) => el && refs.push(el)];
}
const FacilityActivitiesGroupsList = memo(({ options }) => {
	const wrapperRef = useRef();
	const ulRef = useRef();
	const [hiddenCount, setHiddenCount] = useState(null);
	const [loaded, setHasLoaded] = useState(null);
	const [elements, refa] = useArrayRef();
	useEffect(() => {
		// fixes bug from the google map library
		setTimeout(() => {
			setHasLoaded(true);
		}, 100);
	}, []);

	const listRef = useCallback(
		(node) => {
			if (!loaded) return;
			if (node !== null) {
				setTimeout(() => {
					widthCheck(node);
				}, 100);
			}
			if (!ulRef.current) {
				ulRef.current = node;
			}
		},
		[loaded],
	);
	useEffect(() => {
		const debouncedHandleResize = debounce(function handleResize() {
			if (wrapperRef.current === null) return;
			widthCheck(ulRef.current);
		}, 1000);

		window.addEventListener("resize", debouncedHandleResize);
		return (_) => {
			window.removeEventListener("resize", debouncedHandleResize);
		};
	});
	const widthCheck = (parent) => {
		if (!loaded || elements.length < 1) return;
		const parentEl = parent.closest(".info-block-list__counter-block");
		const wrapperWidth = wrapperRef.current.clientWidth;
		const parentWidth = parentEl.clientWidth;
		const contWidth = parentWidth - wrapperWidth;
		const childrenGapCount = Number(
			getComputedStyle(parent).gap.split("px")[0].split(" ")[1],
		);
		let parentChildrenWidth = 0;
		elements.forEach((item) => {
			item.classList.remove("hidden");
			parentChildrenWidth += Math.floor(item.clientWidth) + childrenGapCount;
			if (parentChildrenWidth > contWidth) {
				item.classList.add("hidden");
			}
		});
		const allHidden =
			parent.querySelectorAll(".hidden").length === elements.length
				? true
				: false;
		if (allHidden) {
			elements[0].classList.remove("hidden");
		}
		if (parent.querySelectorAll(".hidden").length) {
			setHiddenCount(parent.querySelectorAll(".hidden").length);
		} else {
			setHiddenCount(null);
		}
	};

	return (
		<div className="info-block-list__counter-block">
			<ul
				ref={listRef}
				className="info-block-list__activities">
				{options.map((group, index) => {
					return (
						<li
							key={group.activityGroupId}
							ref={refa}
							className="hidden">
							{group.name}
						</li>
					);
				})}
			</ul>
			<div
				ref={wrapperRef}
				className="remaining">
				{hiddenCount > 0 ? `+ ${hiddenCount}` : null}
			</div>
		</div>
	);
});
export default FacilityActivitiesGroupsList;
